import { useSwrFetch } from "./useSwrFetch";

interface CompanyReviewEligibilityResponse {
  can_review: boolean;
}

interface UseCompanyReviewEligibilityProps {
  companyId: number | null;
}

interface UseCompanyReviewEligibilityResult {
  canReview: boolean;
  loading: boolean;
}

export function useCompanyReviewEligibility(
  props: UseCompanyReviewEligibilityProps,
): UseCompanyReviewEligibilityResult {
  const { companyId } = props;

  const { data, loading } = useSwrFetch<CompanyReviewEligibilityResponse>({
    url:
      companyId !== null ? `/companies/${companyId}/review-eligibility` : null,
    errorMessage: "Failed to check company review eligibility",
  });

  return {
    canReview: data?.can_review ?? false,
    loading,
  };
}
